import { render, staticRenderFns } from "./HtmlEditor.vue?vue&type=template&id=2853f764&"
import script from "./HtmlEditor.vue?vue&type=script&lang=js&"
export * from "./HtmlEditor.vue?vue&type=script&lang=js&"
import style0 from "./HtmlEditor.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "../Styles/html-editor.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2853f764')) {
      api.createRecord('2853f764', component.options)
    } else {
      api.reload('2853f764', component.options)
    }
    module.hot.accept("./HtmlEditor.vue?vue&type=template&id=2853f764&", function () {
      api.rerender('2853f764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/HtmlEditor/HtmlEditor.vue"
export default component.exports